"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _222Icon = createIcon({
  displayName: "_222Icon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m46.822033 46.822033h173.65401v173.65401h-173.65401z"
        fill="currentColor"
      />
      <path
        d="m279.52396 46.822033h173.65401v173.65401h-173.65401z"
        fill="currentColor"
      />
      <path
        d="m46.822033 279.52396h173.65401v173.65401h-173.65401z"
        fill="currentColor"
      />
      <path
        d="m279.52396 279.52396h173.65401v173.65401h-173.65401z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _222Icon;
